// Prodotti correlati: quando la sezione si avvicina allo schermo carica i consigli di Shopify (Product Recommendations API).
document.querySelectorAll('[data-related]').forEach(function (box) {
  var io = new IntersectionObserver(function (entries) {
    if (!entries[0].isIntersecting) return;
    io.disconnect();
    fetch(box.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var fresh = html.querySelector('[data-related]');
        if (fresh && fresh.innerHTML.trim()) box.innerHTML = fresh.innerHTML;
      })
      .catch(function (e) { console.error(e); });
  }, { rootMargin: '0px 0px 200px 0px' });
  io.observe(box);
});
